import React from 'react'
import { NextPage } from 'next'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { HOTEL_PRODUCT_TYPE } from '../constants/products'

import Layout from '../components/Layout'
import { CustomContext, PageProps } from '../types'
import '../styles/main.scss'
import Hotel from '../components/Hotels'
import {
  getPropsForAppBanner,
  shouldHideAppBanner
} from '../components/AppBanner/utils'
import BANNER_TEXT_VALUES from '../components/AppBanner/constants'

const AppBanner = dynamic(() => import('../components/AppBanner'))
const appBannerValues = BANNER_TEXT_VALUES[HOTEL_PRODUCT_TYPE]

const Hotels: NextPage<PageProps> = ({
  headerHTML,
  footerHTML,
  bootstrapData
}) => {
  const { query } = useRouter() as any // have to force this. useRouter query type is ParsedUrlQuery from querystring lib
  const shouldShowAppBanner = !shouldHideAppBanner(bootstrapData, query)

  return (
    <>
      {shouldShowAppBanner ? (
        <AppBanner
          {...{
            ...getPropsForAppBanner(bootstrapData),
            ...appBannerValues
          }}
        />
      ) : null}
      <Layout headerHTML={headerHTML} footerHTML={footerHTML} partner={null}>
        <Hotel />
      </Layout>
    </>
  )
}

export async function getServerSideProps(ctx: CustomContext) {
  const {
    res: { locals }
  } = ctx

  const {
    bootstrapData,
    bootstrapSETI,
    headerHTML = '',
    footerHTML = ''
  } = locals

  return {
    props: {
      headerHTML,
      footerHTML,
      bootstrapData,
      bootstrapSETI
    }
  }
}

export default Hotels
